import * as React from 'react'
function SvgChevronDoubleRight(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M23.507 7.773l9.704 9.705a4 4 0 010 5.657l-9.704 9.705a2.64 2.64 0 11-3.734-3.733l8.8-8.8-8.8-8.8a2.64 2.64 0 113.734-3.734zm-13 0l9.704 9.705a4 4 0 010 5.657l-9.704 9.705a2.64 2.64 0 11-3.734-3.733l8.8-8.8-8.8-8.8a2.64 2.64 0 113.734-3.734z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgChevronDoubleRight
